<template>
  <div class="leo2-app-home">
    <div class="logo"></div>
    <div class="app-home-tip">
      <img src="/static/images/mobile/tip.png">
    </div>
    <div class="app-home-btn">
      <div @click="startMake(true)" ref="jsonAni"></div>
    </div>

    <div class="mask" v-if="browser.wechat || browser.qq" @click="closeMask()">
      <img v-if="browser.android" src="../assets/images/guide_android.png" />
      <img v-if="browser.ios" src="../assets/images/guide_ios.png" />
    </div>
    <div class="mask-layer" v-if="browser.wechat || browser.qq" @click="closeMask()"></div>
  </div>
</template>

<script>
import { utils } from "../utils";
import { BaseUrl, appsUrl } from "../utils/config.js";
import lottie from "lottie-web";
import installJson from "@/assets/json/other/btn.json";
export default {
  name: 'index',
  data() {
    return {
      install: {},
      isAndroid: false,
      isIos: false,
      downloadUrl: {},
      isDisabled: false,
      browser: {},
      isApps: false,
    }
  },
  mounted() {
    this.isApps = this.$route.query.isApps == 1;
    this.browser = utils.Browser;
    if (this.browser.wechat || this.browser.qq) {
      document.title = ""
    } else {
      document.title = "OK赚 - 一个创造价值的试玩APP";
    }
    this.init();
    this.$nextTick(() => {
      if (this.$refs.jsonAni) {
        lottie.loadAnimation({
          container: this.$refs.jsonAni,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: installJson,
        });
      }
    })
  },
  methods: {
    init() {
      this.axios.install().then((res) => {
        this.install = res.data.data;
        if (parent.frames.length > 0 && this.install.download_type == 1 && this.install.payload_type == 2) {
          //通知上级设置添加主屏幕json
          window.top.postMessage({ cmd: 'install', data: res.data.data }, '*');
        } else if (parent.frames.length > 0 && this.install.download_type == 0 && this.install.payload_type == 2) {
          //下载方式已改变,通知上级重新加载界面
          window.top.postMessage({ cmd: 'reload', url: window.location.href }, '*');
        }
      })
    },
    goPage() {
      this.$router.push({
        path: '/news'
      })
    },
    startMake(bool) {
      const ua = navigator.userAgent.toLowerCase();
      if (utils.Browser.android) { // 安卓
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {   // 微信
          if (bool) {
            this.isAndroid = true;
          }
        } else {
          this.axios.install().then((res) => {
            this.downloadUrl = res.data.data
            window.location.href = this.downloadUrl.DownloadUrl
          })
        }
      } else if (utils.Browser.mac) {
        if (bool) {
          if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0) {   // 微信QQ
            this.$router.push({
              path: '/install'
            })
          } else {
            //添加主屏幕
            window.location.href = (this.isApps ? appsUrl : BaseUrl) + 'ios/wapenter?url=' + window.location.href + '&t=' + new Date().getTime();
          }
        }
      }
    },
    closeMask() { // 关闭提示
      this.isAndroid = false
      this.isIos = false
    },

  }
}
</script>

<style scoped lang="scss">
.leo2-app-home {
  max-width: 750px;
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background: #f44336 url("../assets/imagesMobile/pic.png?v=1") no-repeat center;
  background-size: 100% auto;

  .logo {
    width: 78px;
    height: 45px;
    background: url("../assets/imagesMobile/logo_mobile.png") no-repeat center;
    background-size: 100% auto;
    margin-top: 20px;
    margin-left: 20px;
    clear: both;
    float: left;
    /*img {*/
    /*width: 100%;*/
    /*float: left;*/
    /*}*/
  }

  .news {
    float: right;
    width: 90px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    background-color: #ffa16b;
    margin-top: 35px;
    color: #f44336;
    font-size: 13px;
    border-top-left-radius: 27px;
    border-bottom-left-radius: 27px;
    cursor: pointer;
  }

  .app-home-tip {
    position: absolute;
    bottom: 75px;
    left: 0;
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 199px;
      height: 46px;
    }
  }

  .app-home-btn {
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      width: 248px;
      height: 58px;
    }
  }

  .mask {
    width: 375px;
    position: absolute;
    right: 4px;
    top: 10px;
    z-index: 10000;

    img {
      width: 375px;
    }
  }

  .mask-layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f44336;
    // opacity: 0.7;
    z-index: 1000;
  }
}
</style>
